<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a class="linkstyle" href="https://www.chanchao.com.tw/ExhibitorServiceTW/en">Exhibition List</a>
          <span>/</span>
          <em name="Exhibition">{{ ExhibitionName }}</em>
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="homeLeft">
        <div class="MbDevice">
          <div class="UserAccount ml-1">
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
        </div>
        <p class="my-3">&nbsp;</p>
        <div class="expoLogo">
          <div class="imgCorp squareThumb"><img :src="ExhLogo" width="100%" /></div>
        </div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition">{{ ExhibitionName }}</p>
          <p>{{ Exhdate }}</p>
          <p>{{ eExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
      <div class="homeRight">
        <h1 name="Directory_eComName">{{ Directory_eComName }}</h1>
        <p class="my-3">&nbsp;</p>
        <ul id="progress">
          <li class="progressEdit">
            <div class="progressLeft">
              <div class="profile">
                <h3>
                  <span name="profileTitleEn"></span>
                  <span class="icon incomplete ml-1"></span>
                </h3>

                <p>Please upload your company's logo and fill out your exhibit brands.</p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/profile?no=${RegNo}`"
                    class="btnStyle AddRegLink"
                    >Edit</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
          <li class="progressBook">
            <div class="progressLeft">
              <div class="directory">
                <h3>
                  <span name="homeDirectoryTitleEn"></span>
                  <span class="icon incomplete ml-1"></span>
                </h3>

                <p class="HasDirectory">
                  Please complete your show directory before
                  <span class="red" name="DirectoryDeadline">{{ DirectoryDeadline }}</span
                  >.
                </p>
                <p class="NoDirectory">
                  The information provided with your company will be listed on the exhibition official website in the
                  category of Exhibitor List.
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/directory?no=${RegNo}`"
                    class="btnStyle AddRegLink"
                    >Edit</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
          <li class="progressProd">
            <div class="progressLeft">
              <div>
                <h3>Products</h3>
                <p>
                  Please publish your product description.You have published
                  <span class="red" name="existProd">{{ existProNum }}</span> product(s), you can still create
                  <span class="red" name="leftProd">{{ leftProNum }}</span> product(s).
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${RegNo}`"
                    class="btnStyle AddRegLink"
                    >Edit</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
          <li class="progressNews">
            <div class="progressLeft">
              <div>
                <h3>Press Release</h3>
                <p>
                  Please publish your news.You have published
                  <span class="red" name="existNews">{{ existNewsNum }}</span> news, you can still create
                  <span class="red" name="leftNews">{{ leftNewsNum }}</span> news.
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${RegNo}`"
                    class="btnStyle AddRegLink"
                    >Edit</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
          <li class="progressInvit">
            <div class="progressLeft">
              <div>
                <h3>Invitation</h3>
                <p>You can use E-invitation, client registration and VIP invitation to invite important clients.</p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p><a href="" class="btnStyle getInvUrl">Edit</a></p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
        </ul>
      </div>
      <p class="clear"></p>
    </article>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: `Home - Chan Chao Exhibitor's Online Service System`,
      }
    },

    data() {
      return {
        ExhVenue: '',
        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        eExhVenue: '',

        Exhdate: '',
        DirectoryDeadline: '',
        DirectoryArchived: '',
        RegNo: '',
        ExhibitionName: '',
        Directory_ComName: '',
        UserId: '',
        existProNum: '',
        leftProNum: '',
        existNewsNum: '',
        leftNewsNum: '',
        ProductAmount: '',
        newsAmount: '',
        Directory_eComName: '',
      }
    },

    methods: {},

    created() {
      const vm = this

      let nowPage = location.href
      vm.RegNo = nowPage.split('no=')[1]

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=en`).then((response) => {
        if (response.data.Code == 200) {
          vm.ExhibitionName = response.data.Data.Exhibition
          vm.ExhVenue = response.data.Data.ExhVenue
          vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
          vm.Exhdate = response.data.Data.ExhBegin + ' - ' + response.data.Data.ExhEnd
          vm.DirectoryDeadline = response.data.Data.DirectoryDeadline

          vm.ExhBegin = response.data.Data.ExhBegin
          vm.ExhEnd = response.data.Data.ExhEnd
          vm.eExhVenue = response.data.Data.eExhVenue

          if (response.data.Data.DirectoryArchived == 0) {
            $('.progressBook').addClass('hideDirectory')
          } else {
            $('.progressBook').removeClass('hideDirectory')
          }

          if (response.data.Data.DirectoryHardcopy == 1) {
            $('[name="directoryTitle"]').text('會刊登錄')
            $('[name="directoryTitleEn"]').text('Directory Entry')
            $('[name="profileTitleEn"]').text('Basic Information')
            $('[name="homeCompanyInfo"]').text('基本資料')
            $('[name="homeDirectoryTitle"]').text('會刊登錄')
            $('[name="homeDirectoryTitleEn"]').text('Directory Entry')
            $('.HasDirectory').addClass('show')
            $('.NoDirectory').addClass('hide')
          } else {
            $('[name="directoryTitle"]').text('廠商介紹')
            $('[name="directoryTitleEn"]').text('Exhibitor Profile')
            $('[name="profileTitleEn"]').text('Basic Information')
            $('[name="homeCompanyInfo"]').text('基本資料')
            $('[name="homeDirectoryTitle"]').text('廠商介紹')
            $('[name="homeDirectoryTitleEn"]').text('Exhibitor Profile')
            $('.HasDirectory').addClass('hide')
            $('.NoDirectory').addClass('show')
          }
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
        } else {
          alert('Server is busy, please try again later.1')
        }
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
        if (response.data.Code == 200) {
          vm.Directory_ComName = response.data.Data.Directory_ComName
          vm.Directory_eComName = response.data.Data.Directory_eComName

          if (response.data.Data.Logo && response.data.Data.Logo !== 'default.jpg' && response.data.Data.BrandName) {
            $('div.profile h3 .icon').addClass('complete')
          }

          vm.ProductAmount = response.data.Data.ProductAmount
          vm.newsAmount = response.data.Data.NewsAmount

          axios
            .get(`https://www.chanchao.com.tw/apiExhibitors/Product/${vm.RegNo}?mode=more&Page=`)
            .then((response) => {
              if (response.data.Code == 200) {
                vm.existProNum = response.data.datatotal
                vm.leftProNum = vm.ProductAmount - response.data.datatotal
              } else if (response.data.Code == 404) {
                vm.existProNum = 0
                vm.leftProNum = vm.ProductAmount - 0
              }
            })

          axios.get(`https://www.chanchao.com.tw/apiExhibitors/ExhibitorNews/${vm.RegNo}?Page=1`).then((response) => {
            // console.log(response.data)

            if (response.data.Code == 200) {
              vm.existNewsNum = response.data.datatotal
              vm.leftNewsNum = vm.newsAmount - response.data.datatotal
            } else if (response.data.Code == 404) {
              vm.existNewsNum = 0
              vm.leftNewsNum = vm.newsAmount - 0
            }
          })
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
        } else {
          alert('Server is busy, please try again later.')
        }
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Directory/${vm.RegNo}`).then((response) => {
        // console.log(response.data)
        if (response.data.Data.Product) {
          $('div.directory h3 .icon').addClass('complete')
        }
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=en`).then((response) => {
        if (response.data.Code == 200) {
          $('.progressInvit').removeClass('hideInvit')

          for (var i = 0; i < response.data.Data.length; i++) {
            if (response.data.Data[i].Url == 'inviteReg' || response.data.Data[i].Url == 'invite') {
              // let GetUrl = response.data.Data[i].Url
              // let UrlDelHtml = GetUrl.split('.')[0]
              $('a.getInvUrl').attr('href', response.data.Data[i].Url + '?no=' + vm.RegNo)
            }
          }
        } else {
          $('.progressInvit').addClass('hideInvit')
        }
      })
    },
  }
</script>

<style lang="scss">
  a:hover {
    color: #ffffff;
  }

  .linkstyle:hover {
    color: #0056b3;
  }

  .hide {
    display: none;
  }

  .show {
    display: block;
  }

  #progress li.progressEdit {
    background-image: url('../../assets/images/progressEdit.svg');
  }

  #progress li.progressBook {
    background-image: url('../../assets/images/progressBook.svg');
  }

  #progress li.progressProd {
    background-image: url('../../assets/images/progressProd.svg');
  }

  #progress li.progressNews {
    background-image: url('../../assets/images/progressNews.svg');
  }

  #progress li.progressInvit {
    background-image: url('../../assets/images/progressInvit.svg');
  }

  #progress li h3 span.incomplete {
    width: 18px;
    height: 18px;
    display: inline-block;
    background-image: url('../../assets/images/tickGray.svg');
    background-repeat: no-repeat;
    background-position: left center;
    background-size: auto 100%;
    padding-left: 20px;
  }

  #progress li h3 span.complete {
    background-image: url('../../assets/images/tick.svg');
  }

  .hideDirectory {
    display: none;
  }

  .hideInvit {
    display: none;
  }
</style>
